export default {
    cz: {
        auth: {
            login_header: 'Přihlášení',
            login_description: 'Přihlašte se pomocí svého VACC účtu',
            login_button: 'Přihlásit se',
            cid: 'CID',
            password: 'Heslo',
            remember: 'Zapamatovat přihlášení',
            forgot: 'Zapomněli jste heslo?',
            password_weak: 'Slabé heslo',
            password_medium: 'Středně silné heslo',
            password_strong: 'Silné heslo',
            passwords_not_same: 'Hesla nesouhlasí'
        },
        header: {
            settings: 'Nastavení',
            logout: 'Odhlásit se'
        },
        menu: {
            category: {
                sop: 'SOP',
                tools: 'Nástroje',
                management: 'Správa'
            },
            overview: 'Přehled',
            my_training: 'Můj výcvik',
            mentor_dashboard: 'Přehled mentora',
            atis_gen: 'Atis generátor',
            membership_management: 'Správa členů',
            training_courses_management: "Správa výcvikových kurzů",
            applications_management: "Správa přihlášek",
            logs: "Logy",
            downloads: 'Ke stažení',
            bookings: 'Booking a eventy',
            'training-materials': 'Výcvikové materiály'
        },
        overview: {
            overview_header: 'Základní přehled',
            connections_header: 'Připojení za tento měsíc',
            active_training: 'Aktivní výcvik',
            logs: 'Záznamy za posledních 30 dní',
            statistics: {
                header: 'Statistiky',
                my: 'Moje',
                month_by_atc: 'Měsíční dle ATC',
                month_by_position: 'Měsíční dle pozice'
            }
        },
        my_training: {
            header: 'Aktuální výcvik',
            last_debriefings_header: 'Poslední debriefingy',
            no_debriefings_yet: 'Zatím žádné debriefingy',
            training_requests_heading: 'Žádosti o výcvik',
            solo_endorsements: 'Udělená sóla',
        },
        mentor_dashboard: {
            current_trainings_header: 'Aktuálně probíhající výcviky',
            my_students_header: 'Mí žáci',
            last_debriefings_header: 'Poslední debriefingy'
        },
        training: {
            sweatbox_count: 'Počet sweatboxů',
            online_count: 'Počet online sessions',
            total_training_time: 'Celková doba výcviku',
            last_session: 'Poslední session',
            syllabus_status: 'Stav osnovy',
            started: 'Zahájeno',
            no_students: 'Jsem línej a žádný výcviky nedělám, takže nemám žádný žáky',
            syllabus: 'Osnova výcviku',
            start: 'začátek',
            mentor: 'Mentor',
            intensity: 'Intenzita',
            text_debriefing: 'Textové hodnocení / debriefing',
            topics: 'Témata',
            new_debriefing: 'Nový debriefing',
            debriefings: 'Debriefingy',
            debriefing_info: 'Informace o debriefingu',
            no_debriefing_yet: 'Zatím žádný debriefing',
            no_debriefings_yet: 'Zatím žádné debriefingy',
            solo_endorsements: 'Udělená sóla'
        },
        debriefing: {
            loaded: 'Načten uložený koncept',
            reset_form: 'Resetovat formulář',
            type: 'Typ',
            session_start: 'Začátek session',
            session_end: 'Konec session',
            intensity: 'Intenzita',
            load_from_stats: 'Načíst session z VATSIM stats',
            show_score: 'zobrazovat skóre',
            hide_score: 'nezobrazovat skóre',
            continuous_rating: 'Průběžné hodnocení',
            topic_notes: 'Poznámky k tématu',
            total_assessment: 'Celkové hodnocení',
            minimum_required_score: 'Požadovaný minimální počet bodů pro splnění tohoto cvičení je',
            edit: 'Upravit debriefing'

        }
    },
    sk: {
        auth: {
            login_header: 'Prihlásenie',
            login_description: 'Prihláste sa pomocou svojho VACC účtu',
            remember: 'Zapamätovat prihlásenie'
        },
    }
}
